import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { pageActionFlagsApi } from "../../store/pageActionFlags/actions";
export var GetActionFlags = function (trigger, enable, page, limit, projectId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePageActionFlags: (_a = state.PageActionFlags.responsePageActionFlags) === null || _a === void 0 ? void 0 : _a.data,
            loadingPageActionFlags: state.PageActionFlags.loadingPageActionFlags,
            errorPageActionFlags: state.PageActionFlags.errorPageActionFlags,
        });
    }), responsePageActionFlags = _a.responsePageActionFlags, loadingPageActionFlags = _a.loadingPageActionFlags, errorPageActionFlags = _a.errorPageActionFlags;
    useEffect(function () {
        if (trigger) {
            dispatch(pageActionFlagsApi({
                enable: enable,
                page: page,
                limit: limit,
                projectId: projectId,
            }));
        }
    }, [trigger, enable, page, limit, projectId]);
    return {
        responsePageActionFlags: responsePageActionFlags,
        loadingPageActionFlags: loadingPageActionFlags,
        errorPageActionFlags: errorPageActionFlags,
    };
};
